// extracted by mini-css-extract-plugin
export var backupIcon = "_sh-1";
export var image = "_sh-0";